import React from 'react';

import './Form.scss';

interface Props {
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
}
const Form: React.FC<Props> = ({ children, onSubmit }) => {
  return (
    <form className="form" onSubmit={onSubmit}>
      {children}
    </form>
  );
};

export default Form;
